import React from 'react';
import PropTypes from 'prop-types';

import AdminPageContainer from '../common/AdminPageContainer';
import AdminPageTitle from '../common/AdminPageTitle';
import Loader from '../../common/loader/Loader';
import ErrorMessage from '../common/AdminErrorMessage';
import ConfirmationModal from '../../common/modals/ConfirmationModal';
import { AddLink, EditLink, DeleteButton } from '../common/Buttons';

import useAdminWebinarsPageState from './useAdminWebinarsPageState';

const AdminWebinarsPage = props => {
  const { status, data, deleteConfirmation, openDeleteConfirmation } = useAdminWebinarsPageState(props.history);

  return (
    <AdminPageContainer>
      <AdminPageTitle title="Webinars" />

      <Loader isVisible={status.isLoading} />

      <ErrorMessage isVisible={status.isError && !status.isLoading} />

      <ConfirmationModal state={deleteConfirmation} />

      {!status.isLoading && !status.isError && (
        <>
          <AddLink to="/admin/webinars/add" text="New Webinar" className="my-10px" />

          {data.length === 0 && <p className="admin-empty-message">No Webinars Found</p>}

          {data.map(webinar => {
            return (
              <div key={webinar._id} className="admin-table-row align-items-center">
                <div className="is-flex align-items-center">
                  <div className="ml-20px">
                    <p className="admin-table-row-title">{webinar.name}</p>
                    <p>
                      Description: <strong>{webinar.description}</strong>
                    </p>
                    <p>
                      Price: <strong>{webinar.price}€</strong>
                    </p>
                    <p>
                      Date: <strong>{webinar.date}</strong>
                    </p>
                    <p className="admin-text-sm">
                      id: <strong>{webinar._id}</strong>
                    </p>
                  </div>
                </div>
                <div className="is-flex mt-10px">
                  <EditLink to={`/admin/webinars/${webinar._id}/edit`} />
                  <DeleteButton onClick={openDeleteConfirmation(webinar._id)} className="ml-10px" />
                </div>
              </div>
            );
          })}
        </>
      )}
    </AdminPageContainer>
  );
};

AdminWebinarsPage.propTypes = {
  history: PropTypes.object.isRequired,
};

export default AdminWebinarsPage;
